/* eslint-disable */
<template>
  <div v-loading="isLoading" ref="serverTableRef" class="server-table">
    <el-table
      class="elTable"
      ref="tableObj"
      v-bind="$attrs"
      stripe
      :row-key="primaryKey"
      v-on="$listeners"
      @filter-change="filterChange"
      @sort-change="sortChange"
      :isServerTable="true"
      :data="tableData"
      :maxHeight="tableHeight"
    >
      <el-table-column
        v-if="otherColumn.selection"
        type="selection"
        v-bind="otherColumn.selection"
      >
      </el-table-column>
      <el-table-column
        fixed="left"
        v-if="otherColumn.columnIndex"
        type="index"
        v-bind="otherColumn.columnIndex"
      >
        <template slot="header" slot-scope="scope">
          序号
          <span class="simuateCaretWrapper"></span>
        </template>
        <template slot-scope="scope"
          ><span
            >{{ scope.$index + (currentPage - 1) * pageSize + 1 }}
          </span></template
        >
      </el-table-column>
      <slot></slot>
    </el-table>
    <slot name="setting"></slot>
    <!-- <div
      style="border-top: 1px solid rgba(0, 0, 0, 0.2)"
      v-show="totalPage == 0"
    ></div> -->
    <!-- <div
      style="text-align: right; padding: 10px 0"
      v-show="totalPage > 0 && hasPage"
    > -->
    <div style="text-align: right; padding: 10px 0" v-show="hasPage">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  _isUndefined,
  _isFunction,
  _isNaN,
  _isNull,
  _bind,
  throttle,
  camelToUnderline,
} from '~/util/commonUtil';
// import qs from "qs";
import { util } from '~/util/axiosConf';

const getTablePropList = function (slotsList) {
  var columnList = slotsList.filter(function (item) {
    return (
      item.componentOptions && item.componentOptions.tag == 'el-table-column'
    );
  });
  return columnList.map(function (item) {
    return item.componentOptions.propsData.prop || '';
  });
};

const getColumnById = function (table, columnId) {
  let column = null;
  table.columns.forEach(function (item) {
    if (item.id === columnId) {
      column = item;
    }
  });
  return column;
};

export default {
  props: {
    // 列表是否有分页
    hasPage: {
      type: Boolean,
      default: true,
    },
    // 列表对应字段
    listKey: {
      type: String,
      default: 'res.list',
    },
    // 分页总条数对应字段
    totalKey: {
      type: String,
      default: 'totalCount',
    },
    // 分页当前页对应字段
    currentPageKey: {
      type: String,
      default: 'pageNumber',
    },
    // 分页每页条数对应字段
    pageSizeKey: {
      type: String,
      default: 'pageSize',
    },
    request: {
      type: [Array, Object],
    },
    size: {
      type: Number,
      default: 10,
    },
    url: {
      type: String,
      default: '',
    }, //表格数据请求URL
    handleParam: {
      type: Function,
      default: null,
    }, //
    primaryKey: {
      type: String,
      default: 'uuid',
    }, //主键
    autoRefresh: {
      type: Boolean,
      default: false,
    },
    refreshTime: {
      type: Number,
      default: 10000,
    },
    height: {
      type: Number,
    },
    //接口必填的默认参数
    defaultParam: {
      type: Object,
      default: () => {
        return null;
      },
    },
    otherColumn: {
      type: Object,
      default() {
        return {
          selection: null,
          columnIndex: null,
        };
      },
    },
  },
  created: function () {
    //设置刷新频率
    this.getServerData = throttle(_bind(this.getServerDataTemp, this), 200, {
      trailing: false,
    });
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  mounted: function () {
    this.calcHeight();
    this.refreshData();
  },
  watch: {
    //当url改变后
    url: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.getServerData();
      }
    },
  },
  computed: {
    //总页数
    totalPage() {
      return Math.ceil(parseFloat(this.total / this.pageSize));
    },
  },
  methods: {
    calcHeight() {
      this.$nextTick(() => {
        this.tableHeight = this.$refs.serverTableRef.offsetHeight - 52;
      });
    },
    // 通过预设字段返回对应数据
    findTarget(data, key) {
      let arr = key.split('.'),
        target = data;
      for (let item of arr) {
        if (target[item]) {
          target = target[item];
        } else {
          return null;
        }
      }
      return target;
    },
    initTable() {
      this.tableData = [];
      this.pageSize = 10;
      this.total = 0;
      this.currentPage = 1;
    },
    /**
     * 获取请求参数
     * @param page 当前页
     * @param size 每页显示的条数
     * @param filterObj 过滤对象
     * @returns {*} 组合后的请求参数对象
     */
    defaultGetParam(page, size, filterObj) {
      var filterMap = {};

      this.tablePropList = getTablePropList(this.$slots.default);

      //遍历设置筛选条件
      if (filterObj) {
        Object.keys(filterObj).forEach(columnId => {
          const column = getColumnById(
            this.$refs.tableObj.store.states,
            columnId
          );
          // 只支持多列单个条件搜索，多条件请使用myFilter和别的组件从父组件传入
          filterMap[column.property] = column.filteredValue[0];
        });
      }
      // 设置表格列的搜索条件
      var columns = this.tablePropList.map(function (item) {
        return {
          data: item,
          name: '',
          search: {
            value: _isUndefined(filterMap[item]) ? '' : filterMap[item],
          },
        };
      });

      //执行操作回调
      if (_isFunction(this.handleParam)) {
        return this.handleParam({
          columns: columns,
          // order: orders,
          CurrentPage: page,
          PageSize: size,
        });
      }

      //创建返回
      filterMap.page = page;
      filterMap.size = size;

      return filterMap;
    },
    /**
     * 获取过滤请求参数
     * */
    getFilterParam(filterObj) {
      var filterMap = {};

      //遍历设置筛选条件
      if (filterObj) {
        Object.keys(filterObj).forEach(columnId => {
          const column = getColumnById(
            this.$refs.tableObj.store.states,
            columnId
          );
          // 只支持多列单个条件搜索，多条件请使用myFilter和别的组件从父组件传入
          filterMap[column.property] = column.filteredValue[0];
        });
      }

      return filterMap;
    },
    /**
     * 获得表格数据
     * @returns {*}
     */
    getServerDataTemp: function () {
      //如果有请求正在进行直接返回
      if (this.isLoading) {
        return;
      }
      var url = this.url,
        _self = this;
      _self.isLoading = true;

      let pageParam = {
        size: this.pageSize,
        page: this.currentPage,
      };

      let allParams = {};
      util
        .get(url, {
          params: Object.assign(
            allParams,
            pageParam,
            this.defaultParam,
            this.searchParams,
            this.filterParams,
            this.sortParams
          ),
        })
        .then(result => {
          let data = result || {};
          if (data.status) {
            _self.total =
              data.res.totalCount || data.res.total || data.res.length || 0;
            let listKey = this.findTarget(data, this.listKey) || [];
            if (listKey.length) {
              _self.tableData = listKey;
              _self.sourceData = listKey.slice();
            } else {
              _self.tableData = [];
              _self.sourceData = [];
            }
            //_self.getData();
            _self.tableData =
              data.res.list ||
              data.res.images ||
              data.res.data ||
              data.res ||
              [];
            _self.$emit('data-load-success', result);
          } else {
            _self.initTable();
            _self.$emit('data-load-fail', result);
            // console.error("后台数据查询失败");
          }
          //渲染完成后关闭遮罩
          Vue.nextTick(function () {
            _self.isLoading = false;
          });
          _self.isLoading = false;
        })
        .catch(result => {
          _self.isLoading = false;
          _self.tableData = [];
          _self.sourceData = [];
          _self.initTable();
          _self.$emit('data-load-fail', result);
          console.error('后台数据接口状态异常');
        });
    },
    /**
     * 排序条件发生改变
     * @param  column
     * @param  prop
     * @param  order
     */
    sortChange(obj) {
      if (_isUndefined(obj.prop) || _isNaN(obj.prop) || _isNull(obj.prop))
        return;
      this.sortKey = obj.prop;
      if (obj.order === 'ascending') {
        this.sourceData.sort(this.compare1);
      } else {
        this.sourceData.sort(this.compare2);
      }
      this.getData();
    },
    compare1(value1, value2) {
      if (value1[this.sortKey] < value2[this.sortKey]) {
        return -1;
      } else if (value1[this.sortKey] > value2[this.sortKey]) {
        return 1;
      } else {
        return 0;
      }
    },
    compare2(value1, value2) {
      if (value2[this.sortKey] < value1[this.sortKey]) {
        return -1;
      } else if (value2[this.sortKey] > value1[this.sortKey]) {
        return 1;
      } else {
        return 0;
      }
    },
    /**
     * 过滤条件改变
     * @param filters 过滤条件
     */
    filterChange(filters) {
      this.currentPage = 1;
      this.filterParams = this.getFilterParam(filters);
      this.getServerData();
      this.$emit('filter-change', filters);
    },
    /**
     * 重置过滤条件*/
    resetFilter() {
      this.$refs.tableObj.store.states.filters = {};
      let columns = this.$refs.tableObj.columns;
      columns.map(function (item) {
        if (item.filteredValue) {
          item.filteredValue = [];
        }
      });
      this.$emit('filter-change', []);
    },
    /**
     * 改变当前页回调
     * @param val
     */
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getServerData();
    },
    /**
     * 改变每页显示数据大小
     * @param val
     */
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getServerData();
    },
    getData() {
      if (!this.sourceData.length) {
        this.tableData = [];
        return;
      }
      // 若删除到当前页无数据，默认成第一页
      if (this.sourceData.length <= (this.currentPage - 1) * this.pageSize) {
        this.currentPage = 1;
      }
      const showData = this.sourceData.slice(
        0 + this.pageSize * (this.currentPage - 1),
        this.pageSize * this.currentPage
      );
      this.$emit('currentData', showData.slice());
      this.tableData = showData;
    },
    // 当前表格中显示的数据
    getFormTableCurrent() {
      return this.tableData.slice();
    },
    /**
     * 搜索表格
     * @param prop
     * @param value
     */
    searchTable(prop, value) {
      this.currentPage = 1;
      this.searchParams = {};
      this.searchParams[prop] = value;
      this.getServerData();
    },
    /**
     * 搜索表格&清空过滤条件
     * @param prop
     * @param value
     */
    resetTable(prop, value) {
      this.resetFilter();
      this.currentPage = 1;
      this.searchParams = {};
      this.filterParams = {};
      this.getServerData();
    },
    /**
     * 高级搜索
     * @param conditions
     */
    seniorSearchTable(conditions) {
      this.currentPage = 1;
      this.searchParams = {};
      if (conditions && conditions instanceof Array && conditions.length > 0) {
        conditions.forEach(item => {
          this.searchParams[item.prop] = item.value;
        });
      }
      this.getServerData();
    },
    /**
     * 根据列的key获得列的实例
     * @param prop 列的key
     * @returns {*}
     */
    getColumnByKey(prop) {
      return this.$refs.tableObj.store.states.columns.find(function (item) {
        return item.property === prop;
      });
    },
    /**
     * 获得表格的数据
     */
    getTableData() {
      return this.$refs.tableObj.store.states._data;
    },
    /**
     * 传入表格数据
     */
    setTableData(data) {
      this.tableData = data;
      this.sourceData = data.slice();
      this.total = data.length;
      this.getData();
    },
    refreshData() {
      if (this.$refs.tableObj) this.clearSelection();
      if (this.url != '') {
        this.getServerData();
      }
    },
    findTableDataByProp(prop, value) {
      if (_isUndefined(prop) || _isUndefined(value)) {
        return [];
      }
      return this.$refs.tableObj.store.states._data.filter(function (item) {
        return item[prop] == value;
      });
    },
    findTableData(predicate) {
      if (!_isFunction(predicate)) {
        return [];
      }
      return this.$refs.tableObj.store.states._data.filter(function (item) {
        return predicate(item);
      });
    },
    currentSelect() {
      return this.$refs.tableObj.selection;
    },
    toggleRowSelection(row, selected) {
      return this.$refs.tableObj.toggleRowSelection(row, selected);
    },
    clearSelection() {
      return this.$refs.tableObj.clearSelection();
    },
    selectedRowOnlyOne(row) {
      const states = this.$refs.tableObj.store.states;
      states.isAllSelected = false;
      const oldSelection = states.selection;
      states.selection = [];
      states.selection.push(row);
      if (oldSelection.length !== 1 || oldSelection[0] != row) {
        this.$refs.tableObj.$emit('selection-change', states.selection);
      }
    },
    doLayout() {
      this.$refs.tableObj.doLayout();
    },
    /**
     * 自动刷新的心跳函数，不要直接调用
     */
    heart() {
      //如果是自动刷新未开启或正在进行手动刷新或者之前的自定刷新请求还没结束
      if (!this.autoRefresh || this.isLoading || this.hearting) {
        return;
      }
      var url = this.url,
        param,
        successFn,
        _self = this;
      var states = this.$refs.tableObj.store.states;

      //获得过滤参数
      param = this.defaultGetParam(
        this.currentPage,
        this.pageSize,
        states.filters
      );

      util
        .get(url, param)
        .then(result => {
          if (result) {
            var data = result.data || {};
            if (data.status) {
              //查询正确
              _self.total = data.totalCount;
              let listKey = this.findTarget(data, this.listKey) || [];
              if (listKey.length) {
                _self.tableData = listKey;
              }
              _self.$emit('data-load-success');
            } else {
              //查询错误
              if (this.timer) {
                clearInterval(this.timer);
              } //停止自动刷新
              console.error('后台数据接口返回异常');
            }
          }
          this.hearting = false;
        })
        .catch(result => {
          if (this.timer) {
            clearInterval(this.timer);
          } //停止自动刷新
          this.hearting = false;
          console.error('后台数据接口返回状态异常');
        });
    },
  },
  data() {
    return {
      tableHeight: 300,
      timer: null,
      isLoading: false,
      hearting: true,
      tableData: [],
      tablePropList: [],
      pageSize: 10,
      total: 0,
      currentPage: 1,
      searchParams: {}, //搜索参数
      filterParams: {}, //过滤参数
      sortParams: {}, //排序参数
      sourceData: [],
      sortKey: '',
    };
  },
};
</script>

<style lang="less" scoped>
.el-dropdown-menu {
  max-height: 310px;
  overflow-y: auto;
  min-width: 50px;
}

.server-table {
  position: relative;
}

.setting-btn {
  position: absolute;
  top: 12px;
  right: 10px;
}
.elTable /deep/ .el-table__fixed::before{
  height:0;
}
</style>